module.exports = __webpack_public_path__ + "static/media/f_eyebrowshape_upward.35394cd1.png";